'use strict';

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _notify = require('linksoft/notify');

var _notify2 = _interopRequireDefault(_notify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resx = (0, _localize2.default)("Common");

var $ = require("jquery");
var userComplaintService = abp.services.api.userComplaint;

module.exports = exports.default = function () {
		$('#btn-add-note-submit').off("click").on("click", function () {
				var isInternal = $("#IsInternal").is(':checked');
				var text = $("#Text").val();
				$("#Text").val('');

				var userComplaintId = $("#UserComplaintId").val();
				var state = $("#State option:selected").val();
				var stateText = $("#State option:selected").text();

				userComplaintService.addNote({
						UserComplaintId: userComplaintId,
						Text: text,
						State: state,
						IsInternal: isInternal
				}).done(function (result) {
						$("#notesGrid").DataTable().ajax.reload(null, false);
						$("td#cell-state label").text(stateText);
						_notify2.default.success(resx.Common.UpdateSuccess);
				}).fail(function (result) {
						_notify2.default.error(result.responseJSON.error.message);
				});
		});
};


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/userComplaints.js
// module id = 459
// module chunks = 0